/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Who owes the next move on a transaction.
 * @export
 */
export const TransactionTurn = {
    Operator: 'operator',
    Client: 'client',
    Buyer: 'buyer',
    None: 'none'
} as const;
export type TransactionTurn = typeof TransactionTurn[keyof typeof TransactionTurn];


export function TransactionTurnFromJSON(json: any): TransactionTurn {
    return TransactionTurnFromJSONTyped(json, false);
}

export function TransactionTurnFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransactionTurn {
    return json as TransactionTurn;
}

export function TransactionTurnToJSON(value?: TransactionTurn | null): any {
    return value as any;
}

